import { useState } from 'react';
import { faqs } from '@/mocks/home';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="mx-auto px-4 md:px-6 max-w-3xl">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-4">
            常见问题
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            你关心的，都在这里
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            关于征途国际App下载与使用的常见疑问解答
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="rounded-xl bg-background-50 overflow-hidden transition-all duration-300"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors duration-200"
              >
                <span className="text-sm md:text-base font-medium text-foreground-950 pr-4">
                  {faq.question}
                </span>
                <div className={`w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0 transition-all duration-300 ${
                  openIndex === index ? 'bg-primary-500 text-background-50 rotate-45' : 'bg-background-200 text-foreground-500'
                }`}>
                  <i className="ri-add-line text-sm"></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 ease-in-out overflow-hidden ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed pl-4 border-l-2 border-primary-300">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}